import theme from '@styles/theme';
export default {
  priceArea: {
    pt: '8px'
  },
  priceRow: {
    position: 'relative',
    display: 'flex',
    flexWrap: 'wrap',
    columnGap: '8px',
    rowGap: '4px'
  },
  productCardInfoPrice: (isPromo = false) => ({
    fontFamily: theme.fonts.uniformExtra,
    letterSpacing: '0.05em',
    fontSize: theme.fontSizes.bigText,
    color: isPromo ? theme.rawColors.accent700 : theme.rawColors.neutralBlack,
    span: {
      textWrap: 'nowrap'
    },
    small: {
      color: theme.rawColors.omnibus,
      fontSize: theme.fontSizes.smallText,
      ml: '4px',
      position: 'relative',
      textWrap: 'nowrap',
      '&:after': {
        content: '""',
        position: 'absolute',
        height: '1px',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        background: theme.rawColors.darkGrey300,
        width: '100%'
      }
    }
  }),
  omnibus: {
    width: '100%'
  },
  gpsr: {
    position: 'absolute',
    width: '43px',
    height: '24px',
    top: 0,
    right: 0,
    zIndex: theme.zIndex.documentHigh
  }
};